//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"

export const POST_CreatePOUploadVerification = "api/send-po-upload-verification-mail"
export const GET_POUploadVerificationDetails ="api/validate-token"
export const POST_POStoreFiles = "/api/store-po-files"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//New API URL
export const POST_login = "/api/login"
export const POST_Logout = "/api/logout"
export const Get_EmailVerify = "/api/email-verify/"

//User
export const GET_users = "/api/users"
export const GET_userdetail = "/api/user-details/"
export const POST_AddUser = "/api/users"
export const GET_UserPermission = "api/user-permission"
export const GET_UserCompanyInfo = "api/user-company-info"
export const POST_UserActiveInactiveDelete = "api/active-deactive-user"
export const POST_RESEND_INVITE = "/api/resend-invention"

//Roles
export const GET_roles = "/api/roles"
export const GET_Resource = "/api/resource"
export const GET_RoleDetails = "api/roles-details/"
export const POST_AddRoles = "api/roles"

//Comman
export const GET_UserSalutation = "/api/user-salutation"
export const GET_RoleType = "/api/role-type"
export const GET_GSTTreatment = "api/GST-treatment"
export const GET_PaymentTerms = "api/payment-terms"
export const GET_Countries = "api/countries"
export const GET_Cities = "api/cities"
export const GET_State = "api/states"
export const GET_Currency = "api/currency"
export const GET_Pincode = "api/pin-code"
export const GET_ShipmentPreference = "api/shipment-preference"
export const GET_AdditionalCharges = "api/additional-charges"
export const POST_UploadDocumnet = "api/upload-document"
export const GET_CarrierList = "api/carrier"
export const ADD_Carrier = "api/store-carrier"
export const POST_ADD_CITY = "api/add-city"

//Contacts(Vendors & Customers)
export const GET_ContactTypeVendor = "api/contact?contact_type=vendor"
export const GET_ContactTypeCustomer = "api/contact?contact_type=customer"
export const GET_ContactDetail = "api/contact/"
export const POST_AddContact = "api/contact"
export const GET_ContactPOList = "api/contact-po/"
export const GET_ContactShipmentList = "api/contact-shipment/"
export const GET_VendorPayments = "api/payment"
export const POST_ContactActiveInactive = "api/active-deactive-contact"
export const POST_SmsSetting = "api/enable-disable-sms-setting"

export const POST_VendorInvoice = "api/vendor-invoice-list-for-payment"
export const POST_VendorPaymentCreate = "api/create-payment"
export const GET_ORGANIZATION_DETAILS = "api/edit-organization/"
export const POST_ORGANIZATION_DETAILS = "api/organization"
export const GET_Customer_invoice_list = "api/customer-invoice-list"


//Purchase Order
export const GET_OrganisationDetail = "api/organization-details"
export const GET_TermsAndCondition = "api/terms-and-conditions"
export const GET_CreateTermsAndCondition = "api/terms-and-condition"
export const GET_PurchaseOrderList = "api/po-list"
export const DEL_DeletePOImage = "api/delete-po-image"
export const POST_CreatePurchaseOrder = "api/create-po"
export const POST_DeleteCancelPO = "api/delete-cancel"
export const GET_PurchaseOrderDetail = "api/po-details/"
export const GET_TaxDropDownList = "api/tax"
export const POST_CreateTermsAndConditionGroup =
  "api/create-terms-and-condition-group"
export const POST_CreateTermsAndCondition =
  "api/create-terms-and-condition"
export const GET_GroupTermsCondition = "api/group-terms-condition/"
export const GET_TdsTypes = "api/tds-types"
export const DELETE_poImage = "api/delete-po-image"

// Customer PO 
export const GET_CustomerPODetail = "api/customer-po-details/"
export const POST_CreateCustomerPO = "api/create-customer-po"
export const GET_OrganisationListCustomer = "api/org-details-for-customer"
export const GET_CustomerPOList = "api/customer-po-list"
export const POST_DeleteCustomerPO = "api/delete-cancel-customer-po"
export const POST_createCustomer_PO = "api/create-po"
export const POST_createCustomer_SO = "api/create-customer-so"
export const DELETE_CustomerPoImage = "api/delete-customer-po-image"
export const GET_CustomerPayments = "api/customer-payment"
export const POST_CustomerInvoice = "api/org-invoice-list-for-payment"
export const POST_CustomerPaymentCreate = "api/customer-create-payment"
export const GET_CustomerOrgs = "api/org-list"
export const GET_CustomerShipment = "api/customer-org-shipment-list"
export const GET_StateList = "api/states"
export const POST_POBillingShippingAddress = "/api/store-contact-address"


//Currency Conversion
export const GET_CURRENCY_CON_LIST = "api/currency-conversion"
export const POST_DELETE_CURRENCY = "api/delete-currency-conversion"
export const GET_ALL_CURRENCY = "api/currency"
export const POST_CURRENCY_CON = "api/create-currency-conversion"
export const GET_CURRENCY_CON_DETAILS = "api/currency-conversion-details/"


// Invoice module
export const POST_CREATE_INVOICE = "api/create-invoice"
export const GET_INVOICE_LIST = "api/invoice"
export const GET_ORG_INVOICE_LIST = "api/org-invoice-list"
export const GET_INVOICE_DETAILS = "api/invoice-details"
export const GET_VENDOR_SUPPLY_STATE = "api/get-vendor-supply-state/"
export const DELETE_Invoice_File = "api/delete-invoice-file/"

//Product
export const GET_ProductList = "api/product"
export const GET_ProductDetail = "api/product/"

//Sales Order
export const POST_CreateSalesOrder = "api/create-so"
export const GET_SalesOrderDetails = "api/so-details/"
export const GET_SalesList = "api/so-list"
export const POST_SOAcceptReject = "api/accept-reject"
export const POST_AmmendRequest = "api/ammend-request"
export const POST_AmmendRequest_for_org = "api/org-ammend-request"
export const GET_soNumberListFoAddPackageAndShipment = "api/so-number-list-for-add-package-and-shipment"

// Org SO 
export const GET_OrgSalesList = "api/org-so-list"
export const GET_OrgSalesOrderDetails = "api/org-so-details/"
export const POST_OrgSOAcceptReject = "api/accept-reject-org-so"
export const GET_ORGANIZATION_INVOICE_LIST = "api/customer-org-invoice-list"
export const POST_ORG_INVOICE = "api/create-org-invoice"
export const GET_ORG_INVOICE_DETAIL = "api/org-invoice-details/"
export const GET_InvoiceOrganisationDetail = "api/invoice-organization-details"
export const GET_PackageOrgSoItemList = "api/package-so-item-list"
export const GET_ShipmentOrgDetails = "api/org-customer-shipment/"
export const GET_ShipmentCustumerDetails = "api/customer-shipment/"


//Forgot Password
export const Post_SendOTPForForgotPassword = "api/generate-otp"
export const POST_VerifyOTP = "api/verify-otp"
export const POST_ForgotPassword = "api/create-password"

//Package
export const GET_PackagesList = "api/package-list"
export const GET_PackageSoItemList = "api/package-so-item-list"
export const POST_CreatePackage = "api/create-package"
export const POST_PackageSoList = "api/package-so-list"
export const POST_PackageDetails = "api/package/"
export const GET_OrgPackagesList = "api/org-package-list"
export const POST_OrgPackage = "api/create-org-package"
export const GET_OrgSoPackagesList = "api/org-package-so-list"
export const GET_OrgSoPackagesItemList = "api/org-package-so-item-list"

//Shipment  
export const GET_ShipmentDetails = "api/shipment/"
export const GET_ShipmentPackageList = "api/shipment-package-list"
export const POST_CreateShipment = "api/create-shipment"
export const GET_ShipmentList = "api/shipment-list"
export const GET_Vendor_ShipmentList = "api/org-shipment-list"
export const GET_OrgShipmentlist = "api/org-customer-shipment-list/"
export const POST_OrgShipmentCreate = "api/create-org-shipment"
export const GET_OrgShipmentPackages = "api/org-shipment-package-list"
export const GET_OrgShipmentDetail = "api/org-shipment/"
export const POST_OrgDirectShipment = "api/create-org-package-shipment"


// Direct Shipment
export const POST_DIRECT_SHIPMENT = "api/create-package-shipment"

//Vendor Dashboard
export const GET_VendorDashboardDetail = "api/vendor-all-org-po"
export const GET_VendorPoList = "api/vendor-po-list"
export const GET_PoFulfillmentSummary = "api/get-po-fulfillment-summary"
export const GET_VendorPoSummary = "api/vendor-po-summary"
export const DOWNLOAD_Po_Item_List = "api/export/vendor-po-items"
